/**
 * Animation variants for framer-motion
 */
export const fadeIn = {
  hidden: { opacity: 0 , scale: 0.97},
  visible: { opacity: 1 , scale: 1},
};

/**
 * Common style objects used throughout the tracker component
 */
export const pointerCursorStyle = { cursor: "pointer" };

export const commonTextStyle = {
  display: "inline-block",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  height: "22px",
};

/**
 * Default time values for manual time entry
 */
export const DEFAULT_START_TIME_12HR = "09:00 AM";
export const DEFAULT_END_TIME_12HR = "09:30 AM";
export const DEFAULT_START_TIME_24HR = "09:00";
export const DEFAULT_END_TIME_24HR = "09:30";

/**
 * Default duration values
 */
export const DEFAULT_DURATION = "00:00:00";
export const DEFAULT_DURATION_30MIN = "00:30:00";

/**
 * Toast notification configuration constants
 */
export const toastConfig = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const toastConfigWithTheme = {
  ...toastConfig,
  theme: "light",
};

export const toastConfigLong = {
  ...toastConfig,
  autoClose: 5000,
};

/**
 * Modal style configurations
 */
export const bulkImportModalStyle = {
  content: {
    height: "50%",
    width: "50%",
    position: "fixed",
    top: "50%",
    left: "50%",
  },
};

export const skippedRowsModalStyle = {
  content: {
    height: "60%",
    width: "60%",
    position: "fixed",
    top: "50%",
    left: "50%",
    overflowY: "auto",
  },
};

export const loadingModalStyle = {
  content: {
    height: "10%",
    width: "10%",
    position: "fixed",
    top: "50%",
    left: "50%",
  },
};

/**
 * Error styles for inputs and containers
 */
export const getErrorBorderStyle = (hasError) => ({
  borderColor: hasError ? "red" : "",
  backgroundColor: hasError ? "#fff9f9" : "",
});

export const getTimeInputErrorStyle = (hasError, isSplitted = false) => ({
  backgroundColor: hasError && !isSplitted ? "#fddada" : undefined,
});

export const getDurationInputErrorStyle = (hasError) => ({
  backgroundColor: hasError ? "#fddada" : undefined,
});

/**
 * Time input wrapper style
 */
export const timeInputWrapperStyle = { position: "relative", display: "inline-block" };

/**
 * Disabled button style
 */
export const disabledButtonStyle = { opacity: "0.6" };

/**
 * Task input className constants
 */
export const taskInputClassName = "px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full";
export const taskInputErrorClassName = "text-field-with-error px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full";

/**
 * Text overflow style for ellipsis
 */
export const textOverflowStyle = { textOverflow: "ellipsis" };
